import React, { useContext, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import getRouterPath from '../helpers/getRouterPath';
import ReferralBanner from './ReferralBanner';
import { CANNACRAFT, GRASSDOOR, MADEBYPAX } from '../constants/website';
import useSegment from '../hooks/segment';
import { toast } from 'react-toastify';

// import appConfig from '../appConfig';
import * as WEBSITES from '../constants/website';
import appContext from '../Context/appContext';
import BeedFooter from './DTC/beed/BeedFooter';
import GetherbFooter from './DTC/getherb/GetherbFooter';
import RightRatioFooter from './DTC/rightRatio/RightRatioFooter';

import LicenseHolder from './LicenseHolder';
import { useSelector } from 'react-redux';
import { useConfigData } from '../Context/ConfigProvider';

const Footer = () => {
  // const {
  //   state: {
  //     user: { inAppWebViewUser }
  //   }
  // } = useContext(appContext);
  const inAppWebViewUser = useSelector(state => state.user.inAppWebViewUser)

  const router = useRouter();
  const appConfig = useConfigData();
  const {
    query: { tab },
    pathname
  } = router;

  const { trackEvent } = useSegment();

  const citiesInFooter = useMemo(() => {
    const cityRoute = process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO ? '/weed-delivery-near-me' : '/weed-delivery-near';
    const cityArray = [];

    if (process.env.NEXT_PUBLIC_APP !== WEBSITES.BENTO) {
      cityArray.push({ label: 'Los Angeles', eventName: 'Los Angeles', href: `${cityRoute}/los-angeles` });
    }

    cityArray.push({ label: 'San Francisco', eventName: 'San Francisco', href: `${cityRoute}/san-francisco` });

    if (process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO) {
      cityArray.push(
        { label: 'San Jose', eventName: 'San Jose', href: `${cityRoute}/san-jose` },
        { label: 'Fremont', eventName: 'Fremont', href: `${cityRoute}/fremont` }
      );
    }

    if (process.env.NEXT_PUBLIC_APP === WEBSITES.GANJAGODDESS) {
      cityArray.push(
        { label: 'Bakersfield', eventName: 'Bakersfield', href: `${cityRoute}/bakersfield` },
        { label: 'Sacramento', eventName: 'Sacramento', href: `${cityRoute}/sacramento` },
        { label: 'Santa Barbara', eventName: 'Santa Barbara', href: `${cityRoute}/santa-barbara` }
      );
    }

    cityArray.push({ label: 'All Cities in CA', eventName: 'Delivery Cities', href: `${cityRoute}` });

    return cityArray;
  }, []);

  const handleNavigationClick = (e, href, name) => {
    e.preventDefault();
    const payload = {
      category: 'Navigation',
      label: 'menu-footer',
      value: name,
      action: 'Click'
    };
    trackEvent(name, payload);
    router.push(href);
  };

  const CategoryListGd = [
    { name: 'Accessories', url: 'cannabis-accessories' },
    { name: 'Vape', url: 'vapes' },
    { name: 'Deals', url: 'deals' },
    { name: 'Concentrates', url: 'cannabis-concentrates' },
    { name: 'All' }
  ];

  if (inAppWebViewUser) {
    return null;
  }

  return (
    <footer
      className={`footer d-lg-block new-footer-design`}
    >
      <div className="footer-bottom-section py-2 hide-for-beed hide-for-getherb hide-for-rightratio d-none">
        <div
          className={`d-lg-flex justify-content-between flex-column flex-lg-row align-items-center container`}
        >
          {process.env.NEXT_PUBLIC_APP === CANNACRAFT ? (
            <div className="left-sec text-center">
              Copyright© 2018-
              {new Date().getFullYear().toString().substring(2)}{' '}
              <a
                className="text-primary"
                href="https://www.cannacraft.com/"
                target="_blank"
                rel="noreferrer"
                onClick={e => {
                  handleNavigationClick(e, 'https://www.cannacraft.com/', 'Cannacraft');
                }}
              >
                CannaCraft
              </a>{' '}
              All rights reserved. Lic. No. <LicenseHolder />
            </div>
          ) : process.env.NEXT_PUBLIC_APP === MADEBYPAX ? (
            <div className="left-sec ">
              © 20
              {new Date().getFullYear().toString().substring(2)} PAX Labs, Inc. All Rights Reserved. PAX, X, and ERA are all
              trademarks of PAX Labs, Inc. Patents and Trademarks:{' '}
              <a href="http://pax.com/IP" target="_blank" rel="noreferrer">
                pax.com/IP
              </a>
              <br />
              <br />
              <LicenseHolder />
            </div>
          ) : (
            <div className="left-sec text-center">
              {`Copyright© ${new Date().getFullYear().toString()} ${appConfig.APP_NAME
                } All rights reserved. Lic. No. `}
              <LicenseHolder />
            </div>
          )}
          {/* F&E */}
          <div className="right-sec text-center d-block d-lg-flex align-items-center">
            <div className="footer-links">
              <div className="item">
                <a
                  href={appConfig.PRIVACY ? appConfig.PRIVACY : '/privacypolicy'}
                  target="_blank"
                  className="footer-links"
                  rel="noreferrer"
                  test-id="#privacy_policy"
                  onClick={e => {
                    handleNavigationClick(e, appConfig.PRIVACY ? appConfig.PRIVACY : '/privacypolicy', 'Privacy policy');
                  }}
                >
                  Privacy Policy
                </a>
              </div>
              <div className="item">
                <a
                  href={appConfig.TERMS ? appConfig.TERMS : '/termsandconditions'}
                  target="_blank"
                  className="footer-links"
                  rel="noreferrer"
                  test-id="#terms_of_use"
                  onClick={e => {
                    handleNavigationClick(e, appConfig.TERMS ? appConfig.TERMS : '/termsandconditions', 'Terms and conditions');
                  }}
                >
                  Terms of Use
                </a>
              </div>
              {true ? (
                <div className="item">
                  <a
                    href="/ccpacompliance"
                    className="footer-links"
                    onClick={e => {
                      handleNavigationClick(e, '/ccpacompliance', 'CCPA Compliance');
                    }}
                  >
                    Do Not Sell My Personal Information
                  </a>
                </div>
              ) : null}
            </div>
            <IconHolder appConfig={appConfig} />
          </div>
        </div>
      </div>

      {/* New footer */}
      <div className="footer-top-section container xx">
        <div className="footer-top-section-inner d-lg-flex gap-2 justify-content-between">
          <div className="website-section">
            <div className="img-holder"><img className="logo" src={appConfig.HEADER_LOGO_WHITE} /></div>
            <div className="half-rem-mt title">
              {appConfig.APP_NAME}
            </div>
            <div>
              Lic. No. <LicenseHolder />
            </div>
          </div>

          <div className="contact-info-section">
            <h5 className="section-title bold ">Customer Support</h5>
            <div className="mb-2">
              <div className="d-flex align-items-center fs-16 mt-1"><span class="icon-phone-call mr-2"></span>{appConfig.SUPPORT_CONTACT}</div>
            </div>
            <div className='mb-2'>
              <div className="d-flex align-items-center fs-16 mt-1"><span class="icon-envelope mr-2"></span>{appConfig.SUPPORT_EMAIL}</div>
            </div>
            <SubscribeWithEmail />
          </div>
          <div className="pages-section">
            <h5 className="section-title bold">Quick Links</h5>
            <div className="footer-section">
              <div className="footer-sub-section">
                <a
                  href={'/faq'}
                  // target="_blank"
                  className="footer-links"
                  rel="noreferrer"
                  test-id="#faq"
                // onClick={e => {
                //   handleNavigationClick(e, appConfig.FAQ_URL ? appConfig.FAQ_URL : '/faq', 'FAQ');
                // }}
                >
                  FAQ
                </a>
                <a
                  href={'/privacypolicy'}
                  // target="_blank"
                  className="footer-links"
                  rel="noreferrer"
                  test-id="#privacy_policy"
                // onClick={e => {
                //   handleNavigationClick(e, appConfig.PRIVACY ? appConfig.PRIVACY : '/privacypolicy', 'Privacy policy');
                // }}
                >
                  Privacy Policy
                </a>
                <a
                  href={'/termsandconditions'}
                  // target="_blank"
                  className="footer-links"
                  rel="noreferrer"
                  test-id="#terms_of_use"
                // onClick={e => {
                //   handleNavigationClick(e, appConfig.TERMS ? appConfig.TERMS : '/termsandconditions', 'Terms and conditions');
                // }}
                >
                  Terms of Use
                </a>
                {/* //uncomment later */}
                {false ? (
                  <div className="item">
                    <a
                      href="/ccpacompliance"
                      className="footer-links"
                      onClick={e => {
                        handleNavigationClick(e, '/ccpacompliance', 'CCPA Compliance');
                      }}
                    >
                      Do Not Sell My Personal Information
                    </a>
                  </div>
                ) : null}
              </div>
              <div className="footer-sub-section" />
            </div>
          </div>
        </div>
        <div className="disclaimer-content text-center mb-4 fs-12">
          <b>Disclaimer:</b> An empty integrated cannabis vaporizer shall be properly disposed of as a hazardous waste at a household hazardous waste collection facility or other approved facility. A spent cannabis cartridge shall be properly disposed of as hazardous waste at a household hazardous waste collection facility or other approved facility.
        </div>
        <div className="bottom-info-content">
          <div className='pb-3 warning-text'>
            <b>Warning:</b> Smoking or consuming marijuana products can expose you to chemicals including marijuana or cannabis smoke, methanol and Δ9-tetrahydrocannabinol (Δ9-THC), which are known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to
            <a
              href='https://www.P65Warnings.ca.gov'
              target="_blank"
              className="footer-links d-inline-block pl-1"
              rel=""
            > www.p65warnings.ca.gov </a>
          </div>
          <div className='pb-3'>Copyright© 20
            {new Date().getFullYear().toString().substring(2)} {appConfig.APP_NAME} All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

const SubscribeWithEmail = () => {
  const { trackEvent } = useSegment();
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setIsValidEmail(validateEmail(emailValue));
  };

  const handleSubscribe = () => {
    if (isValidEmail) {
      trackEvent('Email Captured', { email: email });
      toast.success('Thank you for subscribing!');
      setEmail('');
      setIsValidEmail(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && isValidEmail) {
      handleSubscribe();
    }
  };

  return (
    <div>
      <p className='text-white !text-[14px] mb-2 font-[500]'>Subscribe to receive latest news and exclusive offers</p>
      <div className='d-flex gap-2'>
        <input
          className='bg-white !text-black rounded-[16px] py-[12px] px-[12px] flex-grow text-[16px]'
          placeholder='Enter Email ID here'
          value={email}
          onChange={handleEmailChange}
          onKeyPress={handleKeyPress}
          type="email"
        />
        <button
          className={`rounded-[16px] py-[12px] px-[12px] bg-[#6DA738] text-white ${isValidEmail ? 'cursor-pointer' : 'cursor-not-allowed'
            }`}
          onClick={handleSubscribe}
          disabled={!isValidEmail}
        >
          Subscribe
        </button>
      </div>
    </div>
  )
}

const goSocialPage = (trackEvent, link, app) => {
  if (trackEvent) {
    trackEvent(`Footer Event - ${app}`, {
      category: 'Footer Events',
      action: 'Click',
      label: app
    });
  }
  // open in a new page
  // openInNewTab(link);
  // window.location = link;
};

const IconHolder = ({ appConfig }) => {
  const { trackEvent } = useSegment();
  return (
    <div data-testid="#footer-social-media-section" className="icon-holder">
      {appConfig.INSTAGRAM ? (
        <Link prefetch={false} href={appConfig.INSTAGRAM}>
          <a
            onClick={() => goSocialPage(trackEvent, appConfig.INSTAGRAM, 'Instagram')}
            rel="noopener noreferrer"
            target="_blank"
            test-id="#instagram"
          >
            <i className="icon-instagram" />
          </a>
        </Link>
      ) : null}
      {appConfig.FACEBOOK ? (
        <Link prefetch={false} href={appConfig.FACEBOOK}>
          <a
            onClick={() => goSocialPage(trackEvent, appConfig.FACEBOOK, 'Facebook')}
            rel="noopener noreferrer"
            target="_blank"
            test-id="#facebook"
          >
            <i className="icon-facebook" />
          </a>
        </Link>
      ) : null}
      {appConfig.TWITTER ? (
        <Link prefetch={false} href={appConfig.TWITTER}>
          <a
            test-id="#twitter"
            onClick={() => goSocialPage(trackEvent, appConfig.TWITTER, 'Twitter')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <i className="icon-twitter" />
          </a>
        </Link>
      ) : null}
      {appConfig.LINKEDIN ? (
        <Link prefetch={false} href={appConfig.LINKEDIN}>
          <a onClick={() => goSocialPage(trackEvent, appConfig.LINKEDIN, 'Linkedin')} rel="noopener noreferrer" target="_blank">
            <i className="icon-linkedin" />
          </a>
        </Link>
      ) : null}
      {appConfig.SPOTIFY ? (
        <Link prefetch={false} href={appConfig.SPOTIFY}>
          <a onClick={() => goSocialPage(trackEvent, appConfig.SPOTIFY, 'Spotify')} rel="noopener noreferrer" target="_blank">
            <i className="icon-spotify" />
          </a>
        </Link>
      ) : null}
      {appConfig.TIKTOK ? (
        <Link prefetch={false} href={appConfig.TIKTOK}>
          <a onClick={() => goSocialPage(trackEvent, appConfig.TIKTOK, 'Tiktok')} rel="noopener noreferrer" target="_blank">
            <i className="icon-tiktok" />
          </a>
        </Link>
      ) : null}
      {appConfig.YOUTUBE ? (
        <Link prefetch={false} href={appConfig.YOUTUBE}>
          <a onClick={() => goSocialPage(trackEvent, appConfig.YOUTUBE, 'Youtube')} rel="noopener noreferrer" target="_blank">
            <i className="icon-youtube-play" />
          </a>
        </Link>
      ) : null}
    </div>
  );
};
export default Footer;
